module.exports = __webpack_public_path__ + "static/media/PB_Y_05.3d0d664f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_05.png
// module id = 234
// module chunks = 0